import React from 'react';
import { getFullDate } from '../../../../../commons/CommonMethods';

export const Card = ({
  content = {},
  onClick = () => {},
  borderRadius = 6,
  padding = 10,
}) => {
  const {
    text = '',
    link = '',
    color = '#B5B5B5',
    bg_color = '#ffffff',
    border_color = '#B5B5B5',
    link_color = '#50B547',
    type = 'normal',
    url = '',
    texts = [],
  } = content;

  const handleClick = (e) => {
    return onClick(e, url);
  };

  const getTextTemplate = (texts) => {
    if (!texts || (texts && !texts.length)) return null;

    return (
      texts &&
      texts.map((message, index) => {
        const customStyle = {
          display: message?.same_line ? 'contents' : 'inherit',
        };
        return (
          <React.Fragment key={index}>
            <p
              className='text'
              style={{
                ...customStyle,
                fontWeight: message.type,
                color: message.color,
              }}
            >
              {message.text}{' '}
              {!!message?.timestamp && getFullDate(message?.timestamp * 1000)}
            </p>
            {message.break && <br></br>}
          </React.Fragment>
        );
      })
    );
  };

  return (
    <div
      className='cardWrapper col'
      style={{
        background: bg_color,
        padding: padding,
        borderRadius: borderRadius,
        border: '0.5px solid',
        borderColor: border_color,
        flex: 1,
      }}
    >
      {getTextTemplate(texts)}
      {text && (
        <p
          style={{
            display: 'inline-block',
            color: color,
            fontWeight: type,
          }}
        >
          {text}
          {!!link?.length && (
            <span
              onClick={handleClick}
              style={{
                color: link_color,
                marginLeft: '1rem',
                cursor: 'pointer',
              }}
            >
              {link}
            </span>
          )}
        </p>
      )}
    </div>
  );
};
